import React from 'react';
import { X, Download, FileText, Share2, Mail } from 'lucide-react';
import './QRModal.css';

interface QRModalProps {
  isOpen: boolean;
  qrCodeUrl: string;
  title?: string;
  description?: string;
  onClose: () => void;
  onDownload?: () => void;
  onDownloadVCard?: () => void;
  onShare?: () => void;
  onEmail?: () => void;
}

const QRModal: React.FC<QRModalProps> = ({
  isOpen,
  qrCodeUrl,
  title = 'Scan QR Code',
  description = 'Scan with your phone to save contact',
  onClose,
  onDownload,
  onDownloadVCard,
  onShare,
  onEmail
}) => {
  if (!isOpen) return null;

  return (
    <div className="qr-modal-overlay" onClick={onClose}>
      <div className="qr-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="qr-modal-close" onClick={onClose} aria-label="Close modal">
          <X size={24} />
        </button>
        <div className="qr-modal-header">
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
        <div className="qr-modal-qr">
          <img src={qrCodeUrl} alt="QR Code Large" />
        </div>
        <div className="qr-modal-actions">
          {onDownload && (
            <button onClick={onDownload} className="btn-modal-icon" title="Download QR Code">
              <Download size={20} />
            </button>
          )}
          {onDownloadVCard && (
            <button onClick={onDownloadVCard} className="btn-modal-icon" title="Download vCard">
              <FileText size={20} />
            </button>
          )}
          {onShare && (
            <button onClick={onShare} className="btn-modal-icon" title="Share">
              <Share2 size={20} />
            </button>
          )}
          {onEmail && (
            <button onClick={onEmail} className="btn-modal-icon" title="Email">
              <Mail size={20} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default QRModal;
